import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >

<path d="M3160 6360 c-198 -24 -406 -132 -546 -283 -152 -164 -230 -348 -241
-569 -13 -264 63 -481 237 -671 43 -47 189 -167 203 -167 2 0 8 23 11 52 4 28
12 60 18 71 8 16 0 28 -60 83 -130 118 -203 238 -244 399 -29 114 -22 318 14
421 43 118 89 194 178 288 131 138 306 219 508 233 73 5 97 12 152 41 89 48
123 73 113 83 -10 10 -178 29 -238 28 -22 -1 -69 -5 -105 -9z"/>
<path d="M3505 6251 c-146 -84 -200 -116 -430 -248 -120 -69 -175 -120 -193
-181 -7 -22 -12 -87 -12 -146 0 -129 6 -134 88 -83 31 19 149 88 262 152 113
65 244 140 291 167 162 93 169 106 169 293 0 102 -3 135 -12 134 -7 0 -80 -39
-163 -88z"/>
<path d="M3770 6180 c0 -16 -5 -52 -11 -80 -10 -49 -10 -51 16 -72 101 -79
195 -227 234 -367 55 -197 26 -419 -77 -594 -43 -75 -188 -223 -255 -262 -109
-63 -296 -119 -380 -115 -57 3 -65 0 -72 -27 -3 -15 -15 -45 -26 -67 -10 -22
-19 -41 -19 -43 0 -10 221 -1 282 12 422 88 720 456 721 890 1 240 -83 452
-248 629 -38 40 -143 126 -154 126 -6 0 -11 -13 -11 -30z"/>
<path d="M4685 6045 c-5 -2 -21 -6 -35 -9 -14 -3 -39 -18 -56 -33 -57 -53 -59
-65 -59 -438 l0 -340 67 -3 68 -3 2 233 3 233 78 3 77 3 0 59 0 60 -81 0 -82
0 6 38 c10 57 35 72 128 72 l79 0 0 65 0 65 -92 -1 c-51 0 -97 -2 -103 -4z"/>
<path d="M5615 6041 c-3 -2 -5 -188 -5 -413 l0 -409 68 3 67 3 5 187 c6 207 9
217 80 266 60 40 153 21 190 -40 18 -30 20 -50 20 -225 l0 -193 71 0 71 0 -4
223 -3 224 -37 55 c-45 69 -99 98 -180 98 -73 0 -115 -19 -166 -74 l-42 -45
-2 172 -3 172 -63 1 c-34 0 -65 -2 -67 -5z"/>
<path d="M6340 6043 c-52 -21 -65 -89 -25 -128 48 -49 125 -16 125 52 0 52
-55 94 -100 76z"/>
<path d="M7645 5887 c-4 -18 -5 -152 -3 -298 3 -287 6 -302 61 -343 23 -17 46
-22 123 -24 l94 -4 0 61 0 61 -40 0 c-50 0 -87 17 -94 44 -3 11 -6 85 -6 164
l0 142 60 0 60 0 0 60 0 60 -60 0 -60 0 0 55 0 55 -65 0 -64 0 -6 -33z"/>
<path d="M3325 5735 c-277 -160 -344 -212 -394 -304 -53 -99 -61 -150 -61
-365 0 -106 3 -195 6 -199 3 -3 22 4 42 16 52 31 152 31 204 0 20 -12 39 -19
42 -16 3 4 6 84 6 179 0 235 17 270 166 354 257 142 257 144 262 343 3 110 1
137 -10 136 -7 0 -125 -65 -263 -144z"/>
<path d="M5060 5803 c-60 -22 -140 -104 -163 -169 -19 -55 -23 -168 -7 -226
16 -57 71 -130 120 -160 105 -65 217 -59 297 15 41 38 43 39 45 16 0 -13 1
-31 2 -39 1 -11 17 -16 69 -18 l67 -3 0 180 c0 153 -3 188 -19 231 -26 69 -71
121 -133 155 -46 25 -65 30 -143 32 -64 2 -103 -2 -135 -14z m176 -124 c80
-21 123 -94 112 -194 -13 -114 -136 -177 -244 -125 -96 47 -114 219 -29 287
54 43 89 50 161 32z"/>
<path d="M6802 5799 c-24 -12 -55 -37 -70 -56 l-27 -33 -5 47 -5 48 -67 3 -68
3 0 -296 0 -295 69 0 70 0 3 188 c3 208 9 230 68 270 75 51 179 7 200 -84 5
-21 10 -114 10 -206 l0 -168 65 0 c55 0 65 3 65 18 0 9 1 91 2 182 3 146 5
169 24 200 43 74 126 100 191 60 54 -32 58 -48 63 -260 l5 -195 68 -3 68 -3
-3 223 c-3 206 -5 226 -25 263 -53 99 -151 137 -265 103 -37 -11 -128 -96
-128 -119 0 -18 -18 -8 -24 14 -8 32 -61 85 -103 102 -52 22 -130 19 -181 -6z"/>
<path d="M8166 5800 c-126 -50 -198 -187 -177 -336 20 -141 91 -221 226 -255
71 -18 144 1 197 52 23 21 43 39 45 39 1 0 3 -18 3 -40 l0 -40 71 0 71 0 -4
188 c-3 178 -4 190 -30 242 -55 115 -133 163 -268 167 -66 2 -96 -1 -134 -17z
m213 -135 c88 -45 108 -186 37 -267 -72 -84 -218 -72 -266 22 -37 73 -22 178
32 228 48 43 132 51 197 17z"/>
<path d="M6300 5515 l0 -296 68 3 67 3 0 290 0 290 -67 3 -68 3 0 -296z"/>
<path d="M5905 5068 c-3 -8 -4 -79 -3 -158 l3 -145 90 -3 c105 -4 156 10 190
50 68 81 51 184 -38 243 -38 25 -234 36 -242 13z m195 -63 c59 -31 69 -107 21
-156 -26 -25 -37 -29 -85 -29 l-56 0 0 100 0 100 45 0 c26 0 59 -7 75 -15z"/>
<path d="M6493 5068 c-13 -22 -133 -291 -133 -300 0 -4 16 -8 35 -8 30 0 37 4
49 35 l15 35 71 0 70 0 17 -35 c15 -31 21 -35 55 -35 l38 0 -14 33 c-8 17 -33
75 -56 127 -23 52 -48 110 -56 128 -12 27 -19 32 -49 32 -18 0 -37 -6 -42 -12z
m67 -124 c11 -26 20 -50 20 -55 0 -5 -20 -9 -45 -9 -29 0 -45 4 -45 12 0 19
34 98 42 98 4 0 16 -21 28 -46z"/>
<path d="M6800 5051 c0 -29 2 -30 53 -33 l52 -3 3 -127 3 -128 34 0 35 0 0
130 0 130 50 0 c49 0 50 1 50 30 l0 30 -140 0 -140 0 0 -29z"/>
<path d="M7308 5023 c-136 -296 -126 -263 -80 -263 34 0 40 4 53 33 14 31 15
32 87 35 l73 3 14 -36 c13 -31 20 -35 50 -35 19 0 35 4 35 9 0 9 -18 51 -76
181 -57 125 -56 125 -95 128 -34 3 -36 1 -61 -55z m85 -76 c9 -23 17 -48 17
-55 0 -14 -76 -17 -84 -3 -7 10 31 101 42 101 4 0 15 -19 25 -43z"/>
<path d="M7680 4940 l0 -30 465 0 465 0 0 30 0 30 -465 0 -465 0 0 -30z"/>
<path d="M4620 4900 c0 -20 7 -20 515 -20 508 0 515 0 515 20 0 20 -7 20 -515
20 -508 0 -515 0 -515 -20z"/>
<path d="M2951 4842 c-108 -55 -106 -209 3 -262 105 -51 216 20 216 138 0 106
-121 175 -219 124z"/>
</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
